import {HyperDropDropdown} from "./components/HyperDropDropdown";

const multiSelectDropdowns = document.querySelectorAll<HTMLElement>('.multiselect-dropdown');

let dropdownInstances = [];

for (let dropdown of multiSelectDropdowns) {
  dropdownInstances.push(new HyperDropDropdown({
    elements: {
      root: dropdown,
      checkboxes: dropdown.querySelectorAll('.term-checkbox')
    },
    openOnMouseOver: true
  }))

  dropdown.addEventListener('dropdown:open', (e: Event) => {
    // close other dropdowns
    dropdownInstances.forEach(d => {
      if (d.elements.root !== dropdown) {
        d.close()
        d.unlock()
      }
    });
  })
}

// close dropdowns on outside click
document.addEventListener('click', (event) => {
  if (!event.target.closest('.multiselect-dropdown')) {
    dropdownInstances.forEach(d => {
      d.close()
      d.unlock()
    });
  }
});


